module.exports = __webpack_public_path__ + "static/img/异常检测与风险识别.0280692e.png";